import React, { useState, useEffect, useContext } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import TextArea from 'four-nets/ui-v2/form/text-area/text-area';

import mutation, {
    UpdateImageTitleMutation,
    UpdateImageTitleMutationVariables,
} from './mutations/update-image-title.graphql';
import { useMutation } from '@apollo/client';
import { AlertContext } from 'lib/alert-context/alert-context';

import defaultStyles from './image-title.scss';

interface Props {
    styles: typeof defaultStyles;
    id: string;
    title: string | null;
    close: () => any;
}

const ImageTitleForm: React.FC<Props> = props => {
    const { styles, id, title: initialTitle, close } = props;

    const { fail } = useContext(AlertContext);

    const [title, setTitle] = useState();

    const [updateImageTitle] = useMutation<UpdateImageTitleMutation, UpdateImageTitleMutationVariables>(mutation, {
        variables: { input: { imageId: id, title } },
    });

    useEffect(() => {
        setTitle(initialTitle);
    }, [initialTitle]);

    return (
        <>
            <FormattedMessage id='ADD_IMAGE_DESCRIPTION'>
                {msg => (
                    <TextArea
                        value={title}
                        onChange={e => {
                            setTitle(e.target.value);
                        }}
                        placeholder={msg as string}
                    />
                )}
            </FormattedMessage>

            <div className={styles.buttons}>
                <button
                    className={styles.button}
                    onClick={() => {
                        setTitle(initialTitle);
                        close();
                    }}
                >
                    <FormattedMessage id='CANCEL' values={{ gender: 'v' }} />
                </button>
                <button
                    className={styles.saveButton}
                    onClick={() => {
                        if (initialTitle !== title) {
                            updateImageTitle().catch((err: Error) => {
                                fail!({
                                    body: err.message,
                                    onAccept: () => {
                                        setTitle(initialTitle);
                                    },
                                });
                            });
                        }
                        close();
                    }}
                >
                    <FormattedMessage id='SAVE' values={{ gender: 'v' }} />
                </button>
            </div>
        </>
    );
};

export default Styled(defaultStyles)(ImageTitleForm);
